import { render, staticRenderFns } from "./AddCar.vue?vue&type=template&id=a1aff020&scoped=true"
import script from "./AddCar.vue?vue&type=script&lang=js"
export * from "./AddCar.vue?vue&type=script&lang=js"
import style0 from "./AddCar.vue?vue&type=style&index=0&id=a1aff020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1aff020",
  null
  
)

export default component.exports